import { render, staticRenderFns } from "./ReplacementSection.vue?vue&type=template&id=637a5d0c&scoped=true&"
import script from "./ReplacementSection.vue?vue&type=script&lang=js&"
export * from "./ReplacementSection.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementSection.vue?vue&type=style&index=0&id=637a5d0c&prod&lang=css&"
import style1 from "./ReplacementSection.vue?vue&type=style&index=1&id=637a5d0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637a5d0c",
  null
  
)

export default component.exports